import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Shield,
  UserPlus,
  Upload,
} from "lucide-react";
import { UserRolesRoles } from "./userroles/UserRolesRoles";
import { UserRolesAddUsers } from "./userroles/UserRolesAddUsers";
import { UserRolesBulkUpload } from "./userroles/UserRolesBulkUpload";

export default function UserRolesManagement() {
  const [activeTab, setActiveTab] = useState<string>("roles");

  const userRolesTabs = [
    {
      id: "roles",
      name: "Roles",
      icon: Shield,
    },
    {
      id: "add-users",
      name: "Add Users",
      icon: UserPlus,
    },
    {
      id: "bulk-upload",
      name: "Bulk Upload",
      icon: Upload,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">User/Roles Management</h1>
          <p className="text-muted-foreground">
            Manage user roles and permissions
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          {userRolesTabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id} className="text-sm">
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="roles" className="space-y-6">
          <UserRolesRoles />
        </TabsContent>

        <TabsContent value="add-users" className="space-y-6 mt-6">
          <UserRolesAddUsers />
        </TabsContent>

        <TabsContent value="bulk-upload" className="space-y-6 mt-6">
          <UserRolesBulkUpload />
        </TabsContent>
      </Tabs>
    </div>
  );
}
